import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { getFeatureFlag } from '@/lib/get-feature-flag'
import { getOidc } from '@/features/oidc/oidc'

export const Route = createFileRoute('/_app/your-play/access-controls')({
  beforeLoad: async ({ search, matches }) => {
    const oidc = await getOidc()
    if (oidc.isUserLoggedIn) {
      const userId = oidc.getDecodedIdToken()['pam-aid']

      const { enabled } = await getFeatureFlag({
        flagKey: 'nova-release-access-controls',
        userId,
      })

      if (!enabled) {
        throw notFound()
      }
    }

    // only on exact match on this route, not the child
    if (matches.at(-1)?.id === Route.id) {
      throw redirect({ to: '/your-play/access-controls/all', search })
    }
  },
})
